module.exports = __webpack_public_path__ + "img/emoji_66.f71a0eb0.png";